<template>
  <el-dialog
    :title="model.id ? '编辑成品' : '添加成品'"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="160px"
      size="small"
      inline
    >
      <el-form-item label="名称">
        <div>{{ model.name }}</div>
      </el-form-item>
      <br />
      <el-form-item label="编号" prop="code">
        <!-- <el-input
          v-model.trim="model.code"
          :disabled="
            model.id > 0 &&
            (model.install_base_id != model.base_id ||
              model.receive_base_id > 0 ||
              model.drill_well_id > 0)
          "
        ></el-input> -->
        <el-input v-model.trim="model.code"></el-input>
      </el-form-item>
      <el-form-item
        :label="param.label"
        v-for="param in model.custom_params"
        :key="param.key"
      >
        <el-input
          v-model="param.value"
          v-if="!param.type || param.type == 1"
        ></el-input>
        <el-date-picker
          style="width: 177px"
          v-model="param.value"
          v-else-if="param.type == 2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-select v-model="param.value" v-else-if="param.type == 3">
          <el-option
            v-for="(option, index) in param.options.split('、')"
            :key="option + index"
            :label="option"
            :value="option"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发往基地" prop="base_id" v-if="model.category == 1">
        <BaseSelect v-model="model.base_id"></BaseSelect>
      </el-form-item>
      <el-form-item
        label="入库基地"
        prop="base_id"
        v-if="!model.id && model.category == 2"
      >
        <BaseSelect v-model="model.base_id" :filterBlank="true"></BaseSelect>
      </el-form-item>
      <el-form-item label="组装基地" prop="install_base_id">
        <BaseSelect v-model="model.install_base_id"></BaseSelect>
      </el-form-item>
      <!-- <el-form-item label="状态" prop="status">
        <ItemStatusSelect
          v-model="model.status"
          model="product"
        ></ItemStatusSelect>
      </el-form-item> -->
      <el-form-item label="备注" prop="remark">
        <el-input v-model="model.remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        :disabled="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { productNew, productUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.model.custom_params = []
      }
    },
  },
  data() {
    return {
      submiting: false,
      visible: this.show,
      rules: {
        code: [{ required: true, message: '请填写', trigger: 'blur' }],
        base_id: [{ required: true, message: '请选择', trigger: 'change' }],
        install_base_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      if (this.submiting) return
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          this.submiting = true
          if (this.model.id > 0) {
            let res = await productUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
              this.submiting = false
            }
          } else {
            let res = await productNew(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
              this.submiting = false
            }
          }
        } else {
          console.log('error submit!!')
          this.submiting = false
          return false
        }
      })
    },
  },
}
</script>